module.exports = __webpack_public_path__ + "img/team.09fcebd7.jpg";